import { Link } from "@mui/material";
import { NavLink } from "react-router-dom";

import { appRoutes } from "routes";

import { Root, Title, Info } from "./styles";

const AboutUsInfo = () => {
  return (
    <Root align="center">
      <Title variant="h1">About Us</Title>
      <Info variant="large" gutterBottom>
        JibJab creates personalized digital content and tools,{" "}
        <Link exact to={appRoutes.categoriesPath()} component={NavLink}>
          Ecards
        </Link>{" "}
        and{" "}
        <Link exact to={appRoutes.categoryPath("music-video-ecards")} component={NavLink}>
          Videos
        </Link>
        , to help spread joy, laughter, and love… for all occasions, ages, or anyone who needs a smile on their face.
      </Info>
      <Info variant="large">
        Our content ranges from iconic music videos to our own line of animated JibJab Originals. Plus, we’ve partnered
        with some amazing brands!
      </Info>
    </Root>
  );
};

export default AboutUsInfo;
